const asyncMenu = [
  // {
  //   "path": "/templatesetting",
  //   "remark": "layout",
  //   "name": "模板设置",
  //   "redirect": "/templatesetting/qcfactorandpf",
  //   "hidden": false,
  //   "meta": {
  //     "title": "模板设置",
  //     "icon": "fa-table"
  //   },
  //   "children": [
  //     {
  //       "path":"dictionarysystem",
  //       "remark":"dictionarycomp",
  //       "name":"系统数据配置",
  //       "hidden":false,
  //       "meta":{
  //           "title":"系统数据配置",
  //           "icon":"svg-sjzd"
  //       }
  //     },
  //     {
  //       "path":"dictionaryreport",
  //       "remark":"dictionarycomp",
  //       "name":"检查报告配置",
  //       "hidden":false,
  //       "meta":{
  //           "title":"检查报告配置",
  //           "icon":"svg-sjzd"
  //       }
  //     },
  //     {
  //       "path":"dictionaryconsultation",
  //       "remark":"dictionarycomp",
  //       "name":"会诊系统配置",
  //       "hidden":false,
  //       "meta":{
  //           "title":"会诊系统配置",
  //           "icon":"svg-sjzd"
  //       }
  //     },
  //     {
  //       "path":"dictionarytemplate",
  //       "remark":"dictionarycomp",
  //       "name":"模板数据配置",
  //       "hidden":false,
  //       "meta":{
  //           "title":"模板数据配置",
  //           "icon":"svg-sjzd"
  //       }
  //     },
  //     {
  //       "path":"dictionaryteaching",
  //       "remark":"dictionarycomp",
  //       "name":"规培教学配置",
  //       "hidden":false,
  //       "meta":{
  //           "title":"规培教学配置",
  //           "icon":"svg-sjzd"
  //       }
  //     },
  //   ]
  // }
]

export const defaultMenu = [
  {
    "path": "/home",
    "remark": "layout",
    "name": "首页",
    "redirect": "/home/index",
    "hidden": false,
    "meta": {
      "title": "首页",
      "icon": "fa-home"
    },
    "children": [
      {
        "path":"index",
        "remark":"home",
        "name":"主页",
        "hidden":false,
        "meta":{
            "title":"主页",
        }
      },
    ]
  }
]
export default asyncMenu;



// WEBPACK FOOTER //
// ./src/router/asyncMenu.js